// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"55397dcf7fb49749b97a","293":"52158d2ed63d6a9954e6"}[chunkId] + ".js";
};